import React from "react";
import Base from "../../common/components/Base";
import root from "../../common/containers/root";
import Panel from "./Panel";

class Root extends Base {
	constructor(props, context) {
		super(props, context);
	}

	renderAfterLoad() {
		return (
			<React.Fragment>
				<Panel />
			</React.Fragment>
		);
	}

	render() {
		return this.renderContent(false);
	}
}

export default root(Root);
